import { AdminProfessionals } from '@platform/client';
import { useParams } from 'wouter';
import { AdminDetailPage, DetailPageAction } from '../../AdminDetailPage';
import { ProfileTabContent } from './ProfileTabContent';
import { ResetUserModal } from '../../components/ResetUserModal';
import { AccountTypeEnum, ProfessionalApplicationStatusEnum } from '@platform/client/schemas';
import { useState } from 'react';
import { SingleProAppStatusModal } from './UpdateProApplicationStatusModal';
import { UpdateCohortModal } from './UpdateCohortModal';
import { DisableUserModal } from './DisableUserModal';
import { MatchingTabContent } from './MatchingTabContent';
import { TeamMatchingTabContent } from './TeamMatchingTabContent';

export const ProfessionalDetail = () => {
  const { professionalId } = useParams<{ professionalId: string }>();
  const [resetUserAppModalOpen, setResetUserAppModalOpen] = useState(false);
  const [updateAppStatusModalOpen, setUpdateAppStatusModalOpen] = useState(false);
  const [updateCohortModalOpen, setUpdateCohortModalOpen] = useState(false);
  const [disableUserModalOpen, setDisableUserModalOpen] = useState(false);
  const {
    data: proData,
    isSuccess,
    isError,
    isLoading,
  } = AdminProfessionals.useGetProfessionalReviewData(parseInt(professionalId));
  const pageActions: DetailPageAction[] = [];
  if (proData?.applicationId) {
    pageActions.push({
      text: 'Update Application Status',
      onPress: () => setUpdateAppStatusModalOpen(true),
      type: 'button',
    });
    pageActions.push({
      text: 'Reset Application',
      onPress: () => setResetUserAppModalOpen(true),
      type: 'button',
    });
  }
  if (proData?.cohortName && proData?.corporateClient) {
    pageActions.push({
      text: 'Update Cohort',
      onPress: () => setUpdateCohortModalOpen(true),
      type: 'button',
    });
  }
  pageActions.push({
    text: 'Disable',
    onPress: () => setDisableUserModalOpen(true),
    isDanger: true,
    type: 'button',
  });

  return (
    <>
      <AdminDetailPage
        isError={isError}
        isLoading={isLoading}
        isSuccess={isSuccess}
        title={proData?.name || 'MovingWorlds Professional'}
        tabs={[
          {
            id: 'Profile',
            content: <ProfileTabContent proData={proData} />,
          },
          {
            id: 'Matching',
            content: <MatchingTabContent proId={parseInt(professionalId)} />,
          },
          {
            id: 'Teams',
            content: <TeamMatchingTabContent professionalId={parseInt(professionalId)} />,
          },
        ]}
        pageActions={pageActions}
      />
      {resetUserAppModalOpen && proData && (
        <ResetUserModal
          userId={proData.userId}
          currentAccountType={AccountTypeEnum.experteer}
          currentAppStatus={proData.applicationStatus}
          onClose={() => setResetUserAppModalOpen(false)}
        />
      )}
      {updateAppStatusModalOpen && proData && (
        <SingleProAppStatusModal
          onClose={() => setUpdateAppStatusModalOpen(false)}
          applicationId={proData.applicationId as number}
          status={proData.applicationStatus as ProfessionalApplicationStatusEnum}
          userId={proData.userId}
          isSapPro={proData.corporateClient === 'SAP'}
          queryKeyToInvalidate={AdminProfessionals.getGetProfessionalReviewDataQueryKey(
            proData.userId,
          )}
        />
      )}
      {updateCohortModalOpen && proData?.cohortName && proData.corporateClient && (
        <UpdateCohortModal
          userId={proData.userId}
          onClose={() => setUpdateCohortModalOpen(false)}
          currentCohort={proData.cohortName}
          currentPartner={proData.corporateClient || ''}
          proName={proData.name}
          queryKeyToInvalidate={AdminProfessionals.getGetProfessionalReviewDataQueryKey(
            proData.userId,
          )}
        />
      )}
      {disableUserModalOpen && proData && (
        <DisableUserModal userId={proData.userId} onClose={() => setDisableUserModalOpen(false)} />
      )}
    </>
  );
};
